
import request from '@/utils/request'
import { wisdomsitePrefix, accountPrefix } from './config'

export function operateLogList(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteOperateLog/listByProject',
    method: 'post',
    data
  })
}
export function pageListByProject(data) {
  return request({
    url: accountPrefix + '/front/tenementAgreementUploadLog/pageListByProject',
    method: 'post',
    data
  })
}
export function getFcComparerLogPageList(data) {
  return request({
    url: wisdomsitePrefix + '/front/fcLog/getFcComparerLogPageList',
    method: 'post',
    data
  })
}

